// extracted by mini-css-extract-plugin
export default {"space":"ListPageLayout_space__U85Yn","card":"ListPageLayout_card__2kqYv","maxHeight":"ListPageLayout_maxHeight__gp5xi"};